import { useLang } from '@/context/LanguageContext';
import { motion } from 'framer-motion';
import Marquee from 'react-fast-marquee';
import { Quote } from 'lucide-react';

const clientLogos = [
  'AURORA TECH', 'VANTAGE CO', 'NEXUS GROUP', 'ORBITAL LABS',
  'PRISM DIGITAL', 'ZENITH MEDIA',
];

export default function Testimonials() {
  const { t } = useLang();
  const items = t('testimonials.items') || [];

  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-24 lg:py-32 bg-zinc-950 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 mb-4"
        >
          {t('testimonials.label')}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-5xl lg:text-6xl font-normal tracking-normal text-purple-400 mb-16"
          style={{ fontFamily: "'Great Vibes', cursive" }}
        >
          {t('testimonials.title')}
        </motion.h2>

        {/* Testimonial cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-24">
          {items.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.15 }}
              data-testid={`testimonial-card-${i}`}
              className="bg-zinc-900 border border-white/5 p-8 lg:p-10 hover:border-white/20 transition-colors duration-300 flex flex-col justify-between"
            >
              <div>
                <Quote size={24} className="text-zinc-700 mb-6" />
                <p className="text-base font-manrope text-zinc-300 leading-relaxed mb-8">
                  "{item.quote}"
                </p>
              </div>
              <div>
                <p className="font-outfit font-semibold text-zinc-50">{item.name}</p>
                <p className="text-sm text-zinc-500">{item.role}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Client logos marquee */}
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-600 mb-8 text-center">
            {t('testimonials.clientsLabel')}
          </p>
          <Marquee speed={30} gradient={false}>
            {clientLogos.map((logo, i) => (
              <span
                key={i}
                data-testid={`client-logo-${i}`}
                className="font-outfit text-xl lg:text-2xl font-bold text-zinc-700 hover:text-zinc-400 transition-colors mx-12 lg:mx-20 tracking-tight cursor-default"
              >
                {logo}
              </span>
            ))}
          </Marquee>
        </div>
      </div>
    </section>
  );
}
